<template>
  <div>
    <b-card no-body>
      <b-card-header
        class="d-flex align-items-center"
        header-tag="header"
        role="tab"
        header-bg-variant="dark"
      >
        <div>
          <b>{{ checklistItem.checklistItemDetails.name }}</b>
          <div class="text-muted">
            {{ checklistItem.checklistItemDetails.description }}
          </div>
        </div>

        <b-badge
          class="fixed-width-130 py-1 ml-auto"
          tag="div"
          :variant="getBadge(checklistItem.status)"
        >
          <div class="checklist-item__status">
            {{ checklistItemStatus }}
          </div>
        </b-badge>
      </b-card-header>

      <b-card-body
        v-if="showDocumentUpload"
        class="bg-dark"
      >
        <b-row align-v="end">
          <b-col
            cols="12"
            sm="8"
            lg="5"
          >
            <BaseFileUpload
              v-model="selectedFile"
              accept=".pdf,.jpg,.png,.jpeg,.doc,.docx"
              rules="ext:pdf,jpg,jpeg,png,doc,docx|size:20480"
              :label="`Upload ${checklistItem.checklistItemDetails.name}`"
              placeholder="Select a file"
              class="mb-0"
            />
          </b-col>
          <b-col
            cols="auto"
            class="pl-0"
          >
            <b-button
              variant="primary"
              size="sm"
              class="mb-3"
              :disabled="!selectedFile || isUploading"
              @click="handleUpload"
            >
              <b-spinner
                v-if="isUploading"
                small
                class="mr-1"
              />
              {{ isUploading ? 'Uploading...' : 'Upload' }}
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseFileUpload from '@/components/form/BaseFileUpload.vue'
import { showSuccessMessage, showErrorMessage } from '@/notification-utils'

const statusMapping = {
  'NotRequested': 'In Progress',
  'Requested': 'Requested',
  'Received': 'Received',
  'Verified': 'Verified',
  'Failed': 'Failed',
  'Canceled': 'Canceled',
}

export default {
  name: 'VerificationChecklistItem',

  components: {
    BaseFileUpload
  },

  props: {
    checklistItem: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      selectedFile: null,
      isUploading: false
    }
  },

  computed: {
    checklistItemStatus() {
      const status = this.checklistItem?.status ?? 'NotRequested'

      return statusMapping[status]
    },

    showDocumentUpload() {
      return this.checklistItem.clientDocumentUpload === true
        && this.checklistItem.noteListId !== null
        && this.checklistItem.status !== 'Received'
        && this.checklistItem.status !== 'Verified'
    }
  },

  methods: {
    ...mapActions('verification-checklist', ['uploadChecklistDocument']),

    getBadge(status) {
      switch (status) {
      case 'Not Requested':
      case 'NotRequested':
      case 'Received':
        return 'warning'

      case 'Verified':
        return 'success'

      case 'Failed':
        return 'danger'

      default:
        return 'secondary'
      }
    },

    async handleUpload() {
      if (!this.selectedFile) return

      this.isUploading = true
      try {
        await this.uploadChecklistDocument({
          checklistItemId: this.checklistItem.id,
          noteListId: this.checklistItem.noteListId,
          file: this.selectedFile
        })
        showSuccessMessage('Document uploaded successfully')
        this.selectedFile = null
      } catch (error) {
        showErrorMessage('Failed to upload document. Please try again.')
      } finally {
        this.isUploading = false
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.checklist-item__status {
  font-size: 0.8rem;
}
</style>
